import React, { useEffect, useState } from "react";
import { BlackAndWhite } from "../../../../../../../../themes/Colors";
import {
  BaseButtons,
  CloseButton,
  TextInputFieldSearch,
} from "../../../../../../../../components/atoms";
import { LoadingPopUp } from "../../../../../../../../components";
import useWindowDimensions from "../../../../../../../../components/get-diemensions/UseWindowDiemensions";
import { Bar, Line } from "react-chartjs-2";

const ItemReportDisplay = ({
  setClose,
  display,
  selectedItemrecipetsArray,
  selectedItemrstockTakeTickets,
  selectedItemrtransfersArray,
  setSelecetdInventoryProduct,
  loading,
  productItemsArray,
  selectedInventoryProduct,
  amountSales,
  amountSalesvalue,
  selectedItemFullTransferArray,
  selectedItemFullReceipt,
}) => {
  const { width, height } = useWindowDimensions();

  const [displayGraph, setDisplayGraph] = useState("salesOut");

  //   console.log("selectedItemrtransfersArray", selectedItemrtransfersArray);

  //   console.log("selectedItemrstockTakeTickets", selectedItemrstockTakeTickets);
  //   console.log("selectedItemrecipetsArray", selectedItemrecipetsArray);

  //   console.log("slected product", display);
  //   console.log(" selectedItemFullTransferArray", selectedItemFullTransferArray);
  //   console.log(" selectedItemFullReceipt", selectedItemFullReceipt);
  //   console.log(" selcted recipets", selectedItemrecipetsArray);

  console.log(" amount", amountSales, amountSalesvalue);

  const labelsStockTake = () => {
    let labelsArray = [];
    let totalsArrayStock = [];
    let expectedArrayStock = [];
    if (selectedItemrstockTakeTickets) {
      for (
        let index = 0;
        index < selectedItemrstockTakeTickets.length;
        index++
      ) {
        const element = selectedItemrstockTakeTickets[index];

        labelsArray.push(element.dateCounted.substring(0, 15));
        totalsArrayStock.push(element.stockCount);
        expectedArrayStock.push(element.expected);
      }
      return {
        data: {
          labels: labelsArray,
          valuesArray: totalsArrayStock,
          expectedArrayStock: expectedArrayStock,
        },
      };
    }
  };

  const dataStockTake = {
    labels: labelsStockTake().data.labels,
    datasets: [
      {
        label: "Stock Take", // Setting up the label for the dataset
        labels: ["test"],
        backgroundColor: ["#08356C"], // Setting up the background color for the dataset
        borderColor: ["#08356C"], // Setting up the border color for the dataset
        data: labelsStockTake().data.valuesArray,

        // Setting up the data for the dataset
      },
      {
        label: "Expected report", // Setting up the label for the dataset
        labels: ["test"],
        backgroundColor: ["#48A14D"], // Setting up the background color for the dataset
        borderColor: ["#48A14D"], // Setting up the border color for the dataset
        data: labelsStockTake().data.expectedArrayStock,

        // Setting up the data for the dataset
      },
    ],
  };

  const labelsReceipts = () => {
    let labelsArray = [];
    let totalsArrayReceipts = [];
    let saleAmountArray = [];

    if (selectedItemrecipetsArray) {
      for (let index = 0; index < selectedItemrecipetsArray.length; index++) {
        const element = selectedItemrecipetsArray[index];

        let amount = element.product.retailPriceInc * element.qtyCard.qty;

        labelsArray.push(String("R" + amount.toFixed(2)));
        totalsArrayReceipts.push(Number(element.qtyCard.qty));
        saleAmountArray.push(element.product.baseCostPrice);
      }
      return {
        data: {
          labels: labelsArray,
          valuesArray: totalsArrayReceipts,
          saleAmountArray: saleAmountArray,
        },
      };
    }
  };

  const dataReceipts = {
    labels: labelsReceipts().data.labels,
    datasets: [
      {
        label: "Qty sold", // Setting up the label for the dataset
        labels: ["test"],
        backgroundColor: ["#08356C"], // Setting up the background color for the dataset
        borderColor: ["#08356C"], // Setting up the border color for the dataset
        data: labelsReceipts().data.valuesArray,

        // Setting up the data for the dataset
      },
      {
        label: "Base price ", // Setting up the label for the dataset
        labels: ["test"],
        backgroundColor: ["#48A14D"], // Setting up the background color for the dataset
        borderColor: ["#48A14D"], // Setting up the border color for the dataset
        data: labelsReceipts().data.saleAmountArray,

        // Setting up the data for the dataset
      },
    ],
  };
  const labelsTransfer = () => {
    let labelsArray = [];
    let setAmount = [];
    let expectedAmount = [];

    if (selectedItemrtransfersArray) {
      for (let index = 0; index < selectedItemrtransfersArray.length; index++) {
        const element = selectedItemrtransfersArray[index];

        let amount = element.product.baseCostPrice * element.qtyCard.qty;

        labelsArray.push(String("R" + amount.toFixed(2)));
        setAmount.push(Number(element.qtyCard.qty));
        expectedAmount.push(element.product.baseCostPrice);
      }
      return {
        data: {
          labels: labelsArray,
          valuesArray: setAmount,
          expectedAmount: expectedAmount,
        },
      };
    }
  };

  const dataTransfers = {
    labels: labelsTransfer().data.labels,
    datasets: [
      {
        label: "Received", // Setting up the label for the dataset
        labels: ["test"],
        backgroundColor: ["#08356C"], // Setting up the background color for the dataset
        borderColor: ["#08356C"], // Setting up the border color for the dataset
        data: labelsTransfer().data.valuesArray,

        // Setting up the data for the dataset
      },
      {
        label: "Expected ", // Setting up the label for the dataset
        labels: ["test"],
        backgroundColor: ["#48A14D"], // Setting up the background color for the dataset
        borderColor: ["#48A14D"], // Setting up the border color for the dataset
        data: labelsTransfer().data.expectedAmount,

        // Setting up the data for the dataset
      },
    ],
  };

  const returnData = () => {
    return {
      selectedItemrtransfersArray: selectedItemrtransfersArray,
      selectedItemrstockTakeTickets: selectedItemrstockTakeTickets,
      selectedItemrecipetsArray: selectedItemrecipetsArray,
    };
  };
  const ReturnStockAmount = ({ productId, qty }) => {
    let stock = 0;
    if (productItemsArray) {
      productItemsArray.map((item) =>
        item._id === productId
          ? (stock = item.baseCostPrice.replace(/\\|\,/g, "."))
          : null
      );
    }

    let amount = stock * qty;

    if (qty === 0) {
      return String(0.0);
    }

    return String(Number(amount).toFixed(2));
  };

  const NameAssemble = ({ productId }) => {
    let product;
    if (productItemsArray) {
      productItemsArray.map((item) =>
        item._id === productId ? (product = item) : null
      );
    }

    if (product) {
      let name =
        product.productName +
        " | " +
        product.productSubType +
        " | " +
        product.thcType +
        " | " +
        product.thcContent;
      return name;
    }
  };
  useEffect(() => {
    // here is where the approval fileds will be added for review
    if (display) {
      returnData();
    }
  }, [display]);

  return (
    <div
      style={{
        position: "absolute",
        bottom: 0,
        width: "100%",
        backgroundColor: "#FFFFFF",
        display: "flex",
        flexDirection: "column",
        height: display ? "100%" : 0,
        overflow: "hidden",
        transition: "all 0.2s",
      }}
    >
      <div
        style={{
          position: "absolute",
          top: 20,
          left: 20,
          display: "flex",
          alignItems: "center",
        }}
      >
        <CloseButton
          label={"X"}
          onClick={() => {
            setClose(null);
            setSelecetdInventoryProduct(null);
          }}
        />
        <div style={{ marginLeft: 20, fontSize: 18, fontWeight: "bold" }}>
          INVENTORY REPORTING BREAKDOWN
        </div>
      </div>
      <div
        style={{
          width: width,
          height: height,

          overflowY: "scroll",
          overflowX: "hidden",
        }}
      >
        <div
          style={{
            marginTop: 80,
            width: "100%",
            display: "flex",

            minHeight: 510,
            maxHeight: 510,
          }}
        >
          {/* // product quick info card */}
          <div
            style={{
              borderWidth: 4,
              maxWidth: 300,
              minWidth: 300,
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              marginLeft: 20,
              borderStyle: "solid",
              // borderRadius: 8,
              // WebkitBoxShadow: "0px 0px 7px 2px #00000030",
              borderColor: "#1AB8DB30",
              backgroundColor: BlackAndWhite.secondary,
              //   justifyContent: "center",
            }}
          >
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                marginLeft: 10,
                marginTop: 10,
                width: "95%",
              }}
            >
              <div
                style={{
                  fontSize: 12,
                  fontWeight: "bold",
                  opacity: 0.5,
                  marginBottom: 5,
                }}
              >
                PRODUCT NAME
              </div>
              <div style={{ fontSize: 14, width: "90%" }}>
                {" "}
                {display ? NameAssemble({ productId: display._id }) : "loading"}
              </div>
            </div>
            <div style={{ width: "90%" }}>
              <img
                alt="product image"
                src={display ? display.imageUrl : "loading"}
                style={{ width: "100%" }}
              />
            </div>
            <div style={{ width: "90%", display: "flex" }}>
              <div
                style={{
                  width: "50%",
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                }}
              >
                <div
                  style={{
                    fontSize: 10,
                    fontWeight: "bold",
                    opacity: 0.5,
                    marginBottom: 5,
                  }}
                >
                  IN STOCK
                </div>
                <div style={{ fontSize: 14 }}>
                  {" "}
                  {selectedInventoryProduct
                    ? Number(selectedInventoryProduct.currentStock).toFixed(2)
                    : "loading"}
                </div>
              </div>
              <div
                style={{
                  width: "50%",
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                }}
              >
                <div
                  style={{
                    fontSize: 10,
                    fontWeight: "bold",
                    opacity: 0.5,
                    marginBottom: 5,
                  }}
                >
                  IN STOCK VALUE
                </div>
                <div style={{ fontSize: 14 }}>
                  {" "}
                  R{" "}
                  {selectedInventoryProduct
                    ? ReturnStockAmount({
                        productId: display._id,
                        qty: selectedInventoryProduct.currentStock,
                      })
                    : "loading"}
                </div>
              </div>
            </div>
            <div style={{ width: "90%", display: "flex", marginTop: 20 }}>
              <div
                style={{
                  width: "50%",
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                }}
              >
                <div
                  style={{
                    fontSize: 10,
                    fontWeight: "bold",
                    opacity: 0.5,
                    marginBottom: 5,
                    width: 100,
                    textAlign: "center",
                  }}
                >
                  LIFETIME STOCK IN
                </div>
                <div style={{ fontSize: 14 }}>
                  {" "}
                  {selectedInventoryProduct
                    ? Number(
                        selectedInventoryProduct.lifeTimeOfProductBroughtIn
                      ).toFixed(2)
                    : "loading"}
                </div>
              </div>
              <div
                style={{
                  width: "50%",
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                }}
              >
                <div
                  style={{
                    fontSize: 10,
                    fontWeight: "bold",
                    opacity: 0.5,
                    marginBottom: 5,
                  }}
                >
                  LIFETIME VALUE
                </div>
                <div style={{ fontSize: 14 }}>
                  R{" "}
                  {selectedInventoryProduct
                    ? ReturnStockAmount({
                        productId: display._id,
                        qty: selectedInventoryProduct.lifeTimeOfProductBroughtIn,
                      })
                    : "loading"}
                </div>
              </div>
            </div>
            <div style={{ width: "90%", display: "flex", marginTop: 20 }}>
              <div
                style={{
                  width: "50%",
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                }}
              >
                <div
                  style={{
                    fontSize: 10,
                    fontWeight: "bold",
                    opacity: 0.5,
                    marginBottom: 5,
                  }}
                >
                  SALES OUT
                </div>
                <div style={{ fontSize: 14 }}>
                  {" "}
                  {amountSalesvalue
                    ? Number(amountSalesvalue).toFixed(2)
                    : "loading"}
                </div>
              </div>
              <div
                style={{
                  width: "50%",
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                }}
              >
                <div
                  style={{
                    fontSize: 10,
                    fontWeight: "bold",
                    opacity: 0.5,
                    marginBottom: 5,
                  }}
                >
                  SALES VALUE
                </div>
                <div style={{ fontSize: 14 }}>
                  R {amountSales ? Number(amountSales).toFixed(2) : "loading"}
                </div>
              </div>
            </div>
          </div>
          {/* list displays */}
          <div
            style={{
              flex: 0.966,
              borderStyle: "solid",

              borderWidth: 4,
              // marginLeft: 20,
              // borderRadius: 8,
              //   marginRight: 10,
              borderColor: "#1AB8DB30",
              // WebkitBoxShadow: "0px 0px 7px 2px #00000030",
              backgroundColor: BlackAndWhite.secondary,
              //   marginTop: 20,
              //   marginBottom: 20,
              position: "relative",
            }}
          >
            <div
              style={{
                display: "flex",
                position: "absolute",
                top: 10,
                right: 0,
                width: "100%",
                borderBottomWidth: 2,
                borderBottomStyle: "solid",
                paddingBottom: 10,
                borderColor: "#00000030",
              }}
            >
              <div style={{ minWidth: 10 }} />
              <TextInputFieldSearch borderRadius={4} height={27} />
              <div style={{ flex: 1 }} />
              <BaseButtons
                mini={true}
                label={"STOCK TAKE"}
                borderRadius={4}
                marginTopFalse={true}
                marginRight={5}
                height={30}
                onClick={() => setDisplayGraph("stockTake")}
                invert={displayGraph === "stockTake" ? false : true}
                size={100}
              />
              <BaseButtons
                mini={true}
                label={"SALES OUT"}
                borderRadius={4}
                marginTopFalse={true}
                marginRight={5}
                height={30}
                onClick={() => setDisplayGraph("salesOut")}
                invert={displayGraph === "salesOut" ? false : true}
                size={100}
              />
              <BaseButtons
                mini={true}
                label={"TRANSFERS"}
                borderRadius={4}
                marginTopFalse={true}
                marginRight={5}
                height={30}
                size={100}
                onClick={() => setDisplayGraph("transfer")}
                invert={displayGraph === "transfer" ? false : true}
              />
            </div>
            <div
              style={{
                flex: 1,
                // borderStyle: "solid",
                height: height - 385,
                marginTop: 60,
                maxHeight: 440,
                overflowY: "scroll",
                overflowX: "hidden",
              }}
            >
              {displayGraph === "stockTake"
                ? selectedItemrstockTakeTickets.map((item, index) => {
                    return (
                      <div
                        key={index}
                        style={{
                          width: "99.8%",
                          borderStyle: "solid",
                          borderBottomWidth: 1,
                          borderTopWidth: 0,
                          borderLeftWidth: 0,
                          borderRightWidth: 0,
                          minHeight: 50,
                          display: "flex",
                          alignItems: "center",
                          borderBottomStyle: "solid",
                          borderColor: "#00000030",
                        }}
                      >
                        <div style={{ flex: 0.2 }}>
                          <div style={{ marginLeft: 10, fontSize: 14 }}>
                            <div style={{ fontSize: 10 }}>DATE TAKEN</div>
                            {item.stockTakeDate.substring(0, 15)}
                          </div>
                        </div>
                        <div style={{ flex: 0.2 }}>
                          <div
                            style={{
                              marginLeft: 10,
                              fontSize: 14,
                              display: "flex",
                              flexDirection: "column",
                              justifyContent: "center",
                              alignItems: "center",
                            }}
                          >
                            <div style={{ fontSize: 10 }}>EXPECTED COUNT</div>
                            {Number(item.expected).toFixed(2)}
                          </div>
                        </div>
                        <div style={{ flex: 0.2 }}>
                          <div
                            style={{
                              marginLeft: 10,
                              fontSize: 14,
                              display: "flex",
                              flexDirection: "column",
                              justifyContent: "center",
                              alignItems: "center",
                            }}
                          >
                            <div style={{ fontSize: 10 }}>COUNTED</div>
                            {Number(item.stockCount).toFixed(2)}
                          </div>
                        </div>
                        <div style={{ flex: 0.2 }}>
                          <div
                            style={{
                              marginLeft: 10,
                              fontSize: 14,
                              display: "flex",
                              flexDirection: "column",
                              justifyContent: "center",
                              alignItems: "center",
                            }}
                          >
                            <div style={{ fontSize: 10 }}>DIFFERENCE</div>
                            {Number(item.stockCount - item.expected).toFixed(2)}
                          </div>
                        </div>
                        <div style={{ flex: 0.2 }}>
                          <div
                            style={{
                              marginLeft: 10,
                              fontSize: 14,
                              display: "flex",
                              flexDirection: "column",
                              justifyContent: "center",
                              alignItems: "center",
                            }}
                          >
                            <div style={{ fontSize: 10 }}>COUNTED BY</div>
                            {item.countedBy}
                          </div>
                        </div>
                        <BaseButtons
                          height={30}
                          label={"VIEW COMMENT"}
                          mini={true}
                          marginTopFalse={true}
                          marginLeft={10}
                          marginRight={10}
                        />
                      </div>
                    );
                  })
                : null}
              {displayGraph === "salesOut"
                ? selectedItemrecipetsArray.map((item, index) => {
                    return (
                      <div
                        key={index}
                        style={{
                          width: "99.8%",
                          borderStyle: "solid",
                          borderBottomWidth: 1,
                          borderTopWidth: 0,
                          borderLeftWidth: 0,
                          borderRightWidth: 0,
                          minHeight: 50,
                          display: "flex",
                          alignItems: "center",
                          borderBottomStyle: "solid",
                          borderColor: "#00000030",
                        }}
                      >
                        <div style={{ flex: 0.2 }}>
                          <div style={{ marginLeft: 10, fontSize: 14 }}>
                            <div style={{ fontSize: 10 }}>DATE SOLD</div>
                            {selectedItemFullReceipt[index].dateTime.substring(
                              0,
                              10
                            ) +
                              " " +
                              selectedItemFullReceipt[index].dateTime.substring(
                                11,
                                16
                              )}
                          </div>
                        </div>
                        <div style={{ flex: 0.2 }}>
                          <div
                            style={{
                              marginLeft: 10,
                              fontSize: 14,
                              display: "flex",
                              flexDirection: "column",
                              justifyContent: "center",
                              alignItems: "center",
                            }}
                          >
                            <div style={{ fontSize: 10 }}>QTY </div>
                            {Number(item.qtyCard.qty).toFixed(2)}
                          </div>
                        </div>
                        <div style={{ flex: 0.2 }}>
                          <div
                            style={{
                              marginLeft: 10,
                              fontSize: 14,
                              display: "flex",
                              flexDirection: "column",
                              justifyContent: "center",
                              alignItems: "center",
                            }}
                          >
                            <div style={{ fontSize: 10 }}>COST PRICE</div>R{" "}
                            {Number(
                              String(item.product.baseCostPrice).replace(
                                /\\|\,/g,
                                "."
                              ) * item.qtyCard.qty
                            ).toFixed(2)}
                          </div>
                        </div>
                        <div style={{ flex: 0.2 }}>
                          <div
                            style={{
                              marginLeft: 10,
                              fontSize: 14,
                              display: "flex",
                              flexDirection: "column",
                              justifyContent: "center",
                              alignItems: "center",
                            }}
                          >
                            <div style={{ fontSize: 10 }}>RETAIL PRICE</div>R{" "}
                            {Number(
                              item.product.retailPriceInc * item.qtyCard.qty
                            ).toFixed(2)}
                          </div>
                        </div>
                        <div style={{ flex: 0.2 }}>
                          <div
                            style={{
                              marginLeft: 10,
                              fontSize: 14,
                              display: "flex",
                              flexDirection: "column",
                              justifyContent: "center",
                              alignItems: "center",
                            }}
                          >
                            <div style={{ fontSize: 10 }}>COUNTED BY</div>
                            {selectedItemFullReceipt[index].name}
                          </div>
                        </div>
                      </div>
                    );
                  })
                : null}
              {displayGraph === "transfer"
                ? selectedItemrtransfersArray.map((item, index) => {
                    return (
                      <div
                        key={index}
                        style={{
                          width: "99.8%",
                          borderStyle: "solid",
                          borderBottomWidth: 1,
                          borderTopWidth: 0,
                          borderLeftWidth: 0,
                          borderRightWidth: 0,
                          minHeight: 50,
                          display: "flex",
                          alignItems: "center",
                          borderBottomStyle: "solid",
                          borderColor: "#00000030",
                        }}
                      >
                        <div style={{ flex: 0.2 }}>
                          <div style={{ marginLeft: 10, fontSize: 14 }}>
                            <div style={{ fontSize: 10 }}>DATE RECEIVED</div>
                            {selectedItemFullReceipt.length >= 1
                              ? selectedItemFullTransferArray[
                                  index
                                ].recievedOn.substring(0, 10)
                              : selectedItemFullTransferArray[
                                  index
                                ].dateAdded.substring(0, 10)}
                          </div>
                        </div>
                        <div style={{ flex: 0.2 }}>
                          <div
                            style={{
                              marginLeft: 10,
                              fontSize: 14,
                              display: "flex",
                              flexDirection: "column",
                              justifyContent: "center",
                              alignItems: "center",
                            }}
                          >
                            <div style={{ fontSize: 10 }}>EXPECTED COUNT</div>
                            {Number(item.qtyCard.expected).toFixed(2)}
                          </div>
                        </div>
                        <div style={{ flex: 0.2 }}>
                          <div
                            style={{
                              marginLeft: 10,
                              fontSize: 14,
                              display: "flex",
                              flexDirection: "column",
                              justifyContent: "center",
                              alignItems: "center",
                            }}
                          >
                            <div style={{ fontSize: 10 }}>COUNTED</div>
                            {Number(item.qtyCard.qty).toFixed(2)}
                          </div>
                        </div>
                        <div style={{ flex: 0.2 }}>
                          <div
                            style={{
                              marginLeft: 10,
                              fontSize: 14,
                              display: "flex",
                              flexDirection: "column",
                              justifyContent: "center",
                              alignItems: "center",
                            }}
                          >
                            <div style={{ fontSize: 10 }}>DIFFERENCE</div>
                            {Number(
                              item.qtyCard.qty - item.qtyCard.expected
                            ).toFixed(2)}
                          </div>
                        </div>
                        <div style={{ flex: 0.2 }}>
                          <div
                            style={{
                              marginLeft: 10,
                              fontSize: 14,
                              display: "flex",
                              flexDirection: "column",
                              justifyContent: "center",
                              alignItems: "center",
                            }}
                          >
                            <div style={{ fontSize: 10 }}>COUNTED BY</div>
                            {selectedItemFullTransferArray[index].editedBy}
                          </div>
                        </div>
                      </div>
                    );
                  })
                : null}
            </div>
          </div>
        </div>
        {/* graph displays */}
        <div
          style={{
            paddingTop: 40,
            paddingBottom: 20,
            borderStyle: "solid",
            width: width - 66,
            borderWidth: 4,
            marginLeft: 20,
            // borderRadius: 8,
            marginRight: 10,
            borderColor: "#1AB8DB30",
            // WebkitBoxShadow: "0px 0px 7px 2px #00000030",
            backgroundColor: BlackAndWhite.secondary,
            // marginTop: 20,
            marginBottom: 20,
            position: "relative",
          }}
        >
          <div
            style={{
              width: "95%",
              marginTop: 10,
              flex: 1,
              marginLeft: 20,
            }}
          >
            {displayGraph === "stockTake" ? (
              <Line
                // width={200}
                height={90}
                //   options={}
                data={dataStockTake}
                // style={{ height: 300, width: "20%" }}
              />
            ) : null}
            {displayGraph === "salesOut" ? (
              <Line
                // width={200}
                height={90}
                //   options={}
                data={dataReceipts}
                // style={{ height: 300, width: "20%" }}
              />
            ) : null}
            {displayGraph === "transfer" ? (
              <Line
                // width={200}
                height={90}
                //   options={}
                data={dataTransfers}
                // style={{ height: 300, width: "20%" }}
              />
            ) : null}
          </div>
          <div
            style={{
              display: "flex",
              position: "absolute",
              top: 10,
              right: 0,
            }}
          >
            <BaseButtons
              mini={true}
              label={"STOCK TAKE"}
              borderRadius={4}
              marginTopFalse={true}
              marginRight={10}
              height={30}
              onClick={() => setDisplayGraph("stockTake")}
              invert={displayGraph === "stockTake" ? false : true}
            />
            <BaseButtons
              mini={true}
              label={"SALES OUT"}
              borderRadius={4}
              marginTopFalse={true}
              marginRight={10}
              height={30}
              onClick={() => setDisplayGraph("salesOut")}
              invert={displayGraph === "salesOut" ? false : true}
            />
            <BaseButtons
              mini={true}
              label={"TRANSFERS"}
              borderRadius={4}
              marginTopFalse={true}
              marginRight={10}
              height={30}
              onClick={() => setDisplayGraph("transfer")}
              invert={displayGraph === "transfer" ? false : true}
            />
          </div>
        </div>
      </div>

      <LoadingPopUp display={loading} newWidth={"100%"} />
    </div>
  );
};

export default ItemReportDisplay;
